var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('p',{staticClass:"text"},[_vm._v(" "+_vm._s(_vm.$t('printRedactionSheet.wantToPrint'))+" "),_c('a',{staticClass:"sheet",on:{"click":_vm.downloadSheet}},[_vm._v(" "+_vm._s(_vm.$t('printRedactionSheet.clickHere'))+" ")]),_vm._v(" "+_vm._s(_vm.$t('printRedactionSheet.andDownload'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }